import * as React from "react";

const SvgMoon = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={color} fillRule="nonzero">
      <path d="m20.354 14.708.928.373a1 1 0 0 0-1.3-1.3l.372.927ZM8.646 3l.928.373a1 1 0 0 0-1.301-1.3L8.646 3Z" />
      <path d="M19.981 13.78c-.92.37-1.925.574-2.981.574v2a9.974 9.974 0 0 0 3.727-.718l-.746-1.855ZM17 14.354a8 8 0 0 1-8-8H7c0 5.523 4.477 10 10 10v-2Z" />
      <path d="M9 6.354c0-1.055.204-2.061.574-2.981l-1.856-.746A9.975 9.975 0 0 0 7 6.354h2Z" />
      <path d="M4 11.354a8.003 8.003 0 0 1 5.019-7.426l-.746-1.856A10.003 10.003 0 0 0 2 11.354h2ZM12 19.354a8 8 0 0 1-8-8H2c0 5.523 4.477 10 10 10v-2ZM19.426 14.336A8.003 8.003 0 0 1 12 19.354v2c4.207 0 7.805-2.597 9.282-6.273l-1.856-.745Z" />
    </g>
  </svg>
);

export default SvgMoon;
